import { Component, OnDestroy, OnInit } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { Subscription } from 'rxjs/Subscription';
import { MatDialog } from '@angular/material';
import { ResultDialogComponent } from '../result-dialog/result-dialog.component';

import { AuthGuardService, UserService } from '@core/services';
import { User } from '@shared/models';

@Component({
  selector: 'app-update-password',
  templateUrl: './update-password.component.html',
  styleUrls: ['./update-password.component.css']
})
export class UpdatePasswordComponent implements OnInit, OnDestroy {

    updatePassword: FormGroup;
    private user: User;
    private subscription: Subscription;
    public errorMessage = '';

  constructor(private _fb: FormBuilder,
        private _userService: UserService,
        private _router: Router,
              private _authGuard: AuthGuardService,
              private dialog: MatDialog) {
        this.updatePassword = this._fb.group({
            currentPassword: new FormControl('', [Validators.required]),
            newPassword: new FormControl('', [Validators.minLength(8), Validators.required]),
            confirmPassword: new FormControl('', [Validators.minLength(8), Validators.required])
        });
  }

  ngOnInit() {
        this.subscription = this._userService.getUser().subscribe(user => {
            this.user = user;
        });

        if (this.user.customerIdArray.length > 0) {
            this._authGuard.getAccountInfo();
        }
  }
    ngOnDestroy(){
        this.subscription.unsubscribe();
    }
    onSubmit(){
        if(!this.confirmMatchPasswords() || !this.updatePassword.valid)
          return;

        const passwordData= this.setupPasswordData();
        const updatePasswordEndpoint = 'Account/ChangePassword';
        this._authGuard.authenticatedPost(updatePasswordEndpoint, passwordData).subscribe(
            result => {
                let dialogRef = this.dialog.open(ResultDialogComponent, {
                    data: {
                        title: 'Success',
                        message: 'You have successfully updated your password',
                        alertType: 'success'
                    }
                });
                console.log('Success', result);
                this.updatePassword.reset();

            },
            error => {
                console.log('update password', error);
                this.errorMessage = error;

                let dialogRef = this.dialog.open(ResultDialogComponent, {
                    data: {
                        title: 'Error',
                        message: error,
                        alertType: 'danger'
                    }
                });
            });

    }

    private setupPasswordData(){
        return {
            'OldPassword':this.updatePassword.value.currentPassword,
            'NewPassword':this.updatePassword.value.newPassword,
            'ConfirmPassword':this.updatePassword.value.confirmPassword
        }
    }

    // TODO: Create custom Validator for this.
    private confirmMatchPasswords() {
      let password = String(this.updatePassword.controls.newPassword.value).toString();
      let confirm = String(this.updatePassword.controls.confirmPassword.value).toString();
      return password === confirm;
    }

}



// WEBPACK FOOTER //
// C:/Users/EricChanney/Apps/nexpress-angular-site/src/app/component/update-password/update-password.component.ts